module.exports = __webpack_public_path__ + "static/media/girl.9a3871e4.png";